export interface IOrttoCommunicationBodyKeyParams {
  communicationID: string;
}

export const orttoCommunicationBodyKeys = {
  root: (params: IOrttoCommunicationBodyKeyParams) =>
    ['orttoCommunication', params.communicationID] as const,
  emails: (params: IOrttoCommunicationBodyKeyParams) =>
    [...orttoCommunicationBodyKeys.root(params), 'emails'] as const,
  sms: (params: IOrttoCommunicationBodyKeyParams) =>
    [...orttoCommunicationBodyKeys.root(params), 'sms'] as const,
};

export function parseOrttoCommunicationBodyKey<
  T extends keyof typeof orttoCommunicationBodyKeys
>(queryKey: ReturnType<(typeof orttoCommunicationBodyKeys)[T]>) {
  const [, communicationID] = queryKey;
  return { communicationID };
}
